import React from "react"
import PropTypes from "prop-types"
import { Flex, Modal } from "antd"
// Inline, so its fills follow the guide's theme tokens (an <img> keeps the file's colours: QA #26).
import { ReactComponent as SuccessCheck } from "assets/icons/booking-success-check.svg"
import successClose from "assets/icons/booking-success-close.svg"
import styles from "./BookingSuccessModal.module.css"

// "Booking confirmed": a check, the booking's ID above the title, an optional line under it and, as
// children, what to do next. The guest widget's checkout (Figma 6058:145493, with its next steps) and
// the guide's New Booking (Figma 7378:129723, a 600px modal with the title only) both show it. 40px
// from the screen's sides on a tablet (Figma 6058:146238), 16px on a phone.
const BookingSuccessModal = ({ title, text, idText, width, closeIcon, isOpen, onClose, children }) => (
  <Modal
    open={isOpen}
    onCancel={onClose}
    footer={null}
    centered
    width={width}
    className={styles.successModal}
    maskClosable={false}
    closeIcon={closeIcon}
  >
    <Flex vertical align="center" gap="var(--spacing-xl)" className={styles.successBody}>
      <span className={styles.successIcon}>
        <SuccessCheck aria-hidden="true" />
      </span>
      <Flex vertical align="center" gap="var(--spacing-s)">
        {idText && <span className={styles.successId}>{idText}</span>}
        <h2 className={styles.successTitle}>{title}</h2>
        {text && <span className={styles.successText}>{text}</span>}
      </Flex>
      {children}
    </Flex>
  </Modal>
)

BookingSuccessModal.propTypes = {
  title: PropTypes.string.isRequired,
  // A line under the title; none when null.
  text: PropTypes.string,
  idText: PropTypes.string,
  width: PropTypes.number,
  // AntD's closeIcon: the widget's circled X by default, true for AntD's plain one.
  closeIcon: PropTypes.oneOfType([PropTypes.node, PropTypes.bool]),
  isOpen: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  children: PropTypes.node
}

BookingSuccessModal.defaultProps = {
  text: null,
  idText: null,
  width: 1016,
  closeIcon: <img src={successClose} alt="" width={24} height={24} />,
  isOpen: false,
  children: null
}

export default BookingSuccessModal
